import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeIconContainer: {
      padding: theme.spacing(0.5),
    },
  }),
);

export default useStyles;
